import { useEffect } from "react";
import GoogleDriveService from "service/GoogleDriveService";

const googleDriveService = new GoogleDriveService();
export default function CallbackDrivePage() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get("code");
        googleDriveService.enviarCodigo(code || "").then(() => {
            window.close();
        }).catch((error) => {
            console.error("Erro ao enviar código para o serviço do Google Drive:", error);
        });
    }, [])
    return (
        <div>
            <h1>Callback Drive Page</h1>
            <p>This page is used to handle callback drives.</p>
        </div>
    );
}